import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';
import { InputContext } from '../Input.Context/Input.Context.es.js';

const InputCore = ({ message, className, emphasize = false, children, ...rest })=>{
    const { disabled, loading, error, warning, readOnly, inputLabelId, inputMessageId, label, labelProps, labelSuffix, display } = useContext(InputContext);
    // Input styles
    const inputClass = classNames('cb-input', {
        // Input Error
        error,
        // Input Disabled
        disabled,
        // Input loading
        loading,
        // Input alert
        warning,
        // Input emphasize
        emphasize,
        // Input Read-only
        'read-only': readOnly,
        // Floating Label
        'floating-label': display === 'floating',
        // Has label
        'no-label': !label,
        /**
         * Hide the native placeholder when:
         *
         * We enable floating labels and the label is not empty.
         * This guarantees that we will not show the label as the placeholder since
         * since the label is already positioned inside the input box.
         * See `FloatingLabel` story.
         */ 'no-native-placeholder': display === 'floating' && label
    }, className);
    return jsxs("div", {
        className: inputClass,
        "data-testid": "input-core",
        ...rest,
        children: [
            label && [
                'floating',
                'fixed'
            ].includes(display ?? '') && jsx("div", {
                className: "label-container",
                children: jsxs("label", {
                    className: "label",
                    "data-testid": "label",
                    id: inputLabelId,
                    ...labelProps,
                    children: [
                        label,
                        labelSuffix && jsx("span", {
                            className: "label-suffix",
                            "data-testid": "label-suffix",
                            children: labelSuffix
                        })
                    ]
                })
            }),
            children,
            message != null && jsxs("div", {
                className: "message-container",
                "data-testid": "message",
                id: inputMessageId,
                children: [
                    error && jsx(Icon, {
                        className: "error-icon",
                        name: "ExclamationCircleSolid",
                        size: 16
                    }),
                    message
                ]
            })
        ]
    });
};
InputCore.displayName = 'InputCore';

export { InputCore, InputCore as default };
//# sourceMappingURL=Input.Core.es.js.map
